const resizeVideoPlayer = ({playerSelector = `.js-video`}) => {
  const playersElements = document.querySelectorAll(playerSelector);

  const ASPECT_RATIO_VALUE = 1.777;

  const setHeight = (player) => {
    const playerWidth = player.getBoundingClientRect().width;
    player.style.height = `${playerWidth / ASPECT_RATIO_VALUE}px`;
  };

  if (playersElements.length) {
    playersElements.forEach((player) => {
      setHeight(player);

      window.addEventListener(`resize`, () => setHeight(player));
    });
  }
};

export default resizeVideoPlayer;
